import { render, staticRenderFns } from "./DIDs.vue?vue&type=template&id=3476175d&scoped=true&"
import script from "./DIDs.vue?vue&type=script&lang=js&"
export * from "./DIDs.vue?vue&type=script&lang=js&"
import style0 from "./DIDs.vue?vue&type=style&index=0&id=3476175d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3476175d",
  null
  
)

export default component.exports